import { Box } from '@mui/material';

export default function AppointmentMarker({ visible = true }) {
  return <Box component="span" role={visible ? 'img' : undefined}
    aria-label={visible ? 'Appointments scheduled' : undefined}
    aria-hidden={!visible}
    sx={{ display: 'block', width: 3, height: 3, flexShrink: 0,
      borderRadius: '50%', visibility: visible ? 'visible' : 'hidden',
      bgcolor: theme => theme.palette.mode === 'dark' ? '#9ca3af' : '#6b7280' }} />;
}
